var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"profilePic-container",on:{"click":_vm.selectImage}},[_c('div',{staticClass:"floating front"},[(_vm.image)?_c('img',{attrs:{"src":_vm.image},on:{"error":_vm.handleError}}):_vm._e()]),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"floating back"},[_c('i',{staticClass:"fas fa-user"})])
}]

export { render, staticRenderFns }